/*=========================================================================================
  File Name: moduleTronBot.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Daniyal
==========================================================================================*/


import state from './moduleTronBotState.js'
import mutations from './moduleTronBotMutations.js'
import actions from './moduleTronBotActions.js'
import getters from './moduleTronBotGetters.js'

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}